module.exports = __webpack_public_path__ + "img/trie-08.f01bc5b3.svg";